<template>
  <div class="faad-qualified-pc">
    <a-table
      class="space"
      :data-source="tableData"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
      :scroll="{ y: 'calc(100vh - 300px)', x: 'calc(100vw - 360px)' }"
    >
      <template #action="{ record }">
        <a-popconfirm
          title="确认入库到成品？"
          ok-text="是"
          cancel-text="否"
          @confirm="handleInsertWarehouse(record)"
        >
          <a-button size="small" type="primary"> 入库 </a-button>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>

<script>
import { defineComponent, inject, reactive, watch } from "vue";
import { getPQCList } from "@/request/view/dailyQualityInspection";
import { productColumns } from "@/views/productDaily/components/quality/PQC/threePieced/options";
import { PQCToFQC } from "@/request/view/warehouse";
import { Toast } from "@/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const tableData = reactive([]);

    const route = useRoute();

    const columns = productColumns.filter(
      (f) =>
        f.title !== "流水号" &&
        f.title !== "来源工序" &&
        f.title !== "闭环状态" &&
        f.title !== "第1次送检问题" &&
        f.title !== "第2次送检问题"
    );

    const getData = () => {
      tableData.length = 0;
      getPQCList({
        type: "assembleDebug",
        produceOrTpc: route.meta.produceOrTpc,
        status: "合格",
      }).then((res) => {
        if (res.data) {
          const unWarehousList = [];
          Object.keys(res.data).forEach((date) => {
            const list = res.data[date].filter((f) => !f.isToFQC);
            unWarehousList.push(...list);
          });
          tableData.push(...unWarehousList);
        }
      });
    };

    // 添加到成品入库
    const handleInsertWarehouse = (record) => {
      PQCToFQC({ pqcId: record.id }).then((res) => {
        const type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        getData();
      });
    };

    const activeKey = inject("activeKey", null);

    watch(
      () => activeKey,
      (val) => {
        if (val && val.value === "FAADQualifiedInvetory") {
          getData();
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    return {
      columns,
      tableData,
      handleInsertWarehouse,
    };
  },
});
</script>

<style lang="less" scoped>
.faad-qualified-pc {
  width: 100%;
  height: 100%;

  .space {
    margin-bottom: 10px;
  }
}
</style>
